import selectClient from '../hooks/selectClient';
import liderPalette from './liderPalette';
import mikraPalette from './mikraPalette';
import partnerPalette from './partnerPalette';

let palette;
if (selectClient() === 'Partner' || selectClient() === 'PartnerMKD') palette = partnerPalette;
else if (selectClient() === 'Mikra') palette = mikraPalette;
else if (selectClient() === 'Lider') palette = liderPalette;

const typography = {
  fontSize: 16,
  fontFamily: 'Open Sans',
  fontVariant: 'normal',
  h1: {
    color: palette.text.primary,
    fontWeight: 700,
    fontSize: '32px',
  },
  h2: {
    color: palette.text.primary,
    fontWeight: 700,
    fontSize: '28px',
  },
  h3: {
    color: palette.text.secondary,
    fontWeight: 700,
    fontSize: '24px',
  },
  h4: {
    color: palette.text.primary,
    fontWeight: 600,
    fontSize: '22px',
  },
  h5: {
    color: palette.text.primary,
    fontWeight: 600,
    fontSize: '20px',
  },
  h6: {
    color: palette.text.secondary,
    fontWeight: 600,
    fontSize: '18px',
    lineHeight: 1.4,
  },
  subtitle1: {
    color: palette.text.secondary,
    fontSize: '16px',
    fontWeight: 600,
    lineHeight: 1.35,
  },
  subtitle2: {
    color: palette.text.secondary,
    fontSize: '14px',
    fontWeight: 600,
    lineHeight: 1.35,
  },
  body1: {
    color: palette.text.primary,
    fontSize: '16px',
    fontWeight: 400,
    lineHeight: '20px',
  },
  body2: {
    color: palette.darkGray,
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '19.07px',
  },
  button: {
    color: palette.text.primary,
    fontSize: '0.875rem',
    textTransform: 'none',
    weight: 600,
  },
  caption: {
    color: palette.text.primary,
    fontSize: '12px',
    letterSpacing: '0.33px',
    lineHeight: '12px',
    fontWeight: 400,
  },
  overline: {
    color: palette.text.secondary,
    fontSize: '0.75rem',
    fontWeight: 500,
    letterSpacing: '0.33px',
    lineHeight: '16px',
  },
};

export default typography;
